import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/testimonials")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="testimonials" className="relative py-20 lg:py-28" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.2em] text-sunlit-mute mb-4">In their words</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-sunlit-ink leading-tight">
            Quiet shifts, <span className="italic text-sunlit-gold">loud changes</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t) => (
            <figure
              key={t.id}
              className="rounded-3xl bg-sunlit-cream border border-stone-200/70 p-8 hover:-translate-y-1 hover:shadow-md transition-all"
              data-testid={`testimonial-${t.id}`}
            >
              <Quote className="h-6 w-6 text-sunlit-gold" />
              <blockquote className="mt-4 font-serif-display text-xl leading-snug text-sunlit-ink italic">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-stone-200/70">
                <p className="text-sm font-medium text-sunlit-ink">{t.name}</p>
                {t.role && <p className="text-xs text-sunlit-mute">{t.role}</p>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
